import axios from "axios";
import { api_url } from "../Enviroment";

const ethPrice = "https://pro-api.coingecko.com/api/v3/simple/price";
const get_Project_Transactions = `${api_url}project/get-all-project-transactions`
const get_IsName_Exists = `${api_url}project/check-project-exists`
const get_uniswap_token_rate = `${api_url}uniswap-v3/fetch-token-rate`
const get_signed_data = `${api_url}uniswap-v3/get-signed-data`
const get_uniswap_swapping_data = `${api_url}uniswap-v3/get-token-swap-data`
const get_future_epoch_time = "https://www.timeapi.io/api/Time/current/zone?timeZone=UTC";

export const ethToDollarConverter = async () => {
    try {
        const response = await axios.get(
            ethPrice,
            {
                params: {
                    ids: "ethereum",
                    vs_currencies: "usd",
                },
                headers: {
                    "x-cg-pro-api-key": "CG-AMT6oz8K7Qpx7qESamW9hKZu",
                },
            }
        );
        return response?.data?.ethereum?.usd;
    } catch (error) {
        console.error("Error fetching ETH price:", error);
    }
}

export const projectTransactions = async (pair, currentPage) => {
    try {
        const encodedPair = encodeURIComponent(pair)
        const transationsResponse = await axios.get(`${get_Project_Transactions}/${encodedPair}?page=${currentPage}&limit=10`)
        return transationsResponse?.data?.data
    }
    catch (error) {
        console.error(error)
    }
}

export const getIsNameExists = async (name, symbol, deadline, walletAddress) => {
    try {
        const nameResponse = await axios.get(`${get_IsName_Exists}/${name}/${symbol}/${deadline}/${walletAddress}`)
        return nameResponse?.data?.data
    }
    catch (error) {
        console.error(error)
    }
}

export const getUniswapTokenQuote = async (payload) => {
    try {
        const getQuoteData = await axios.post(get_uniswap_token_rate, payload)
        return getQuoteData?.data
    }
    catch (error) {
        console.error(error)
    }
}

export const getSignedData = async (payload) => {
    try {
        const getSignedData = await axios.post(get_signed_data, payload)
        return getSignedData?.data
    }
    catch (error) {
        console.error(error)
    }
}

export const getSwapRawTransaction = async (payload) => {
    try {
        const getSwapData = await axios.post(get_uniswap_swapping_data, payload)
        return getSwapData?.data
    } catch (error) {
        console.error(error)
    }
}

export const getFutureEpochTime = async () => {
    try {
        const response = await fetch(get_future_epoch_time);
        const data = await response.json();
        const epochTime = Math.floor(new Date(data.dateTime).getTime() / 1000);
        const futureEpochTime = epochTime + 600000;
        return futureEpochTime?.toString();
    } catch (error) {
        console.error("Error fetching time:", error);
    }
}

export const getEpochTime = async (provider) => {
    try {
        const latestBlock = await provider?.getBlock("latest");
        let epochTime = latestBlock?.timestamp;
        epochTime = epochTime + 600;
        return epochTime?.toString();
    } catch (error) {
        console.error("Error fetching SPOC time:", error);
    }
};

export const buyingToken = async (account, contractAddress) => {
    const token = localStorage?.getItem("accessToken");
    try {
        const response = await axios.post(
            `${api_url}user/add-user-coin-held`, { walletAddress: account, contractAddress: contractAddress }, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        }
        )
        return response
    } catch (error) {
        console.error('Registration failed:', error);
    }
};

